import http from "../../utils/http"

/**
 * 获取分页列表
 */
export function pricequotesPage(params) {
    return http({
        url: "/api/pricequotes/page",
        data: params
    })
}
/**
 * 获取详情
 */
export function pricequotesDetail(params) {
    return http({
        url: "/api/pricequotes/info",
        data: params
    })
}
export function pricequotesDetailByDate(params) {
    return http({
        url: "/api/pricequotes/getByDate",
        data: params
    })
}
/**
 * 获取列表
 */
 export function pricequotesList(params) {
    return http({
        url: "/api/pricequotes/list",
        data: params
    })
}
